enum IUserRole {
  HEAD = 'Head',
  ANALYST = 'Analyst',
  ACCOUNT_MANAGER = 'Account Manager',
  DELIVERY_LEAD = 'Delivery Lead',
  RECRUITER = 'Recruiter',
}

export default IUserRole;
